$(function() {
    function addInverseHeader(){
            $(".new-sticky-header").addClass("scroll-active");
            $(".header__heading").addClass("scroll-active-logo");
            $(".header-navs").addClass("scroll-active-navs");
            $(".header__search").addClass("scroll-active-header__search");
            $(".icon__heart").addClass("scroll-active-icon__heart");
            $(".signUp-class").addClass("scroll-active-signUp-class");
            $(".account-class").addClass("scroll-active-account-class");
            $(".svg-margin").addClass("scroll-active-svg-margin");
            $(".cart-style").addClass("scroll-active-cart");
            $(".hamburger-svg-icon").addClass("scroll-active-hamburger");
            $(".customer__link").addClass("scroll-active-customer__link");
    }
    function removeInverseHeader(){
            $(".new-sticky-header").removeClass("scroll-active");
           $(".header__heading").removeClass("scroll-active-logo");
            $(".header-navs").removeClass("scroll-active-navs");
            $(".header__search").removeClass("scroll-active-header__search");
            $(".icon__heart").removeClass("scroll-active-icon__heart");
            $(".signUp-class").removeClass("scroll-active-signUp-class");
            $(".account-class").removeClass("scroll-active-account-class");
            $(".svg-margin").removeClass("scroll-active-svg-margin");
            $(".cart-style").removeClass("scroll-active-cart");
            $(".hamburger-svg-icon").removeClass("scroll-active-hamburger");
            $(".customer__link").removeClass("scroll-active-customer__link");
    }
    $(window).on("scroll", function() {
        //Enavi homepage hero AB test
        if(document.querySelector('html').dataset.heroAb == "true"){
          addInverseHeader();
        }
        //Homepage hero AB test end
        else if($(window).scrollTop() > 10) {
            addInverseHeader();
            $(".new-sticky-header").addClass("scr");
        } else {
            const megaMenu = document.querySelector(".megamenu");
            if (megaMenu){
                let isVisible = window.getComputedStyle(megaMenu).opacity == 1;
                if(isVisible===true){
                    return;
                } 
            }
           removeInverseHeader();
           $(".new-sticky-header").removeClass("scr");
        }
    });
    $(document).ready(function(){
        if(true) {
            document.body.addEventListener('mouseover',function(e){
                const newTargetTest = e.target;
                const header = document.querySelector('.new-sticky-header');
                const isWhite = newTargetTest.classList.contains("toggle_white")
                            ||  !!newTargetTest.closest(".toggle_white") || newTargetTest.classList.contains('header-wrapper') || newTargetTest.classList.contains('header__inline-menu') || newTargetTest.classList.contains('header-wrapper') || newTargetTest.classList.contains('header__inline-menu'); 
                //Enavi homepage hero AB test
                if(document.querySelector('html').dataset.heroAb == "true"){
                  addInverseHeader();
                }
                //Homepage hero AB test end
                else if (isWhite) {
                    addInverseHeader();
                }
                else if (!header.classList.contains("scr") 
                        || $(window).scrollTop() <= 10) {
                    removeInverseHeader();
                }

            });
            // $('.new-sticky-header').delegate(".list-menu--inline","mouseenter", function(e) {
            //     addInverseHeader();
            //     console.log(e.target);
            //     console.log(e.currentTarget);
            // });
            // $('.new-sticky-header').delegate(".list-menu--inline","mouseleave", function(e) {
            //     removeInverseHeader();
            // });
        }

    })
});
// var element=document.getElementsByClassName("new-sticky-header");
// var listener=element.addEventListener('mouseover',function(event){                          
        
//  }); 
// $(function() {
//     $(".list-menu--inline").on("hover", function(){
//       $(.new-sticky-header).css({'background-color': '#ffffff'});
//    });
//    $(".list-menu--inline").on("hover", function(){
//     $(.new-sticky-header).css({'background-color': 'transparent'});
//  });
//   });
// var header = document.getElementById('header-wrapper');
// var oldColor = header.style.backgroundColor;
// document.body.addEventListener('scroll', () => {
//     let yPosition = document.body.scrollTop;
//     if (yPosition > 100) {
//         console.log("newer");
//         header.style.backgroundColor = "teal";
//     }
//     else {
//         header.style.backgroundColor = oldColor;
//     }
// })
// $(document).ready(function () {
//     var scroll_pos = 0;
//     $(document).scroll(function () {
//         scroll_pos = $(this).scrollTop();
//         if (scroll_pos > 100) {
//             console.log("newest");
//             $(".new-sticky-header").css("background-color", "black");
//             $(".new-sticky-header").css("height", "auto");
//         } else {
//             $(".new-sticky-header").css("background-color", "");
//         }
//     });
// });